<template>
    <template v-if="currentStep !== VERIFY_STATUSES.approved">
        <div class="pb-4 text-xs text-gray-280 dark:text-gray-190">
            We require identity verification to comply with telecom regulations
            and prevent fraud. Your data is encrypted and securely stored
        </div>

        <div class="p-3 flex max-mob:flex-col items-center gap-y-3 bg-purple-60 dark:bg-blue-770 rounded-custom">
            <div class="text-xs text-gray-370 dark:text-white">
                Press Start to proceed with identification. You will be redirected to the service to load your passport ID
            </div>

            <PrimaryBtn
                class="min-w-30 max-mob:w-full"
                :loading="loading"
                height="h-10"
                @click="onStartIdenfy"
            >
                Start
            </PrimaryBtn>
        </div>
    </template>

    <template v-else>
        <div class="pb-3 text-xs font-medium text-gray-370 dark:text-white">
            Passport ID
        </div>

        <SuccessBlock
            height="h-auto"
            messages="Your documents successfully verified!"
        />
    </template>
</template>

<script setup>
import {
    ref, onUnmounted, watch, computed, onMounted,
} from 'vue'

import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import SuccessBlock from '@/components/successBlock/SuccessBlock.vue'

import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

import { VERIFY_STATUSES } from '@/constants/verifyStatuses'

const verificationUserStore = useVerificationUserStore()

const currentStep = ref(VERIFY_STATUSES.active)

const statusInterval = ref(null)
const loadIdenfy = ref(false)

const idenfyStatus = computed(() => verificationUserStore.idenfyStatus)
const loading = computed(() => VERIFY_STATUSES.reviewing === idenfyStatus.value || loadIdenfy.value)
const scan_ref = computed(() => verificationUserStore.scan_ref)

onMounted(() => {
    if (verificationUserStore.idenfyIsVerify) {
        changeStep(VERIFY_STATUSES.approved)
    }
})

function changeStep(newStep) {
    currentStep.value = newStep
}

async function onStartIdenfy() {
    loadIdenfy.value = true

    const { success } = await verificationUserStore.goToVerificationIdenfy()

    if (success) {
        window.open(verificationUserStore.idenfyUrl, '_blank')
    }

    loadIdenfy.value = false
}

function setStatusInterval() {
    clearInterval(statusInterval.value)

    verificationUserStore.goToCheckVerificationIdenfyStatus()

    statusInterval.value = setInterval(() => {
        verificationUserStore.goToCheckVerificationIdenfyStatus()
    }, 10000)
}

watch(idenfyStatus, (idenfyStatus) => {
    if (idenfyStatus === VERIFY_STATUSES.approved) {
        changeStep(VERIFY_STATUSES.approved)
        verificationUserStore.setIdenfyIsVerify(true)
        clearInterval(statusInterval.value)
    }
})

watch(scan_ref, (scan_ref) => {
    if (idenfyStatus.value === VERIFY_STATUSES.approved) {
        changeStep(VERIFY_STATUSES.approved)
    }

    if (scan_ref) {
        setStatusInterval()
    }
}, { immediate: true })

onUnmounted(() => {
    clearInterval(statusInterval.value)
})
</script>
